import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import clsx from "clsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
export const Button = forwardRef(({ label, icon, iconEnd, onClick, disabled, primary, outlined, active, className, size = "m", buttonProps, }, ref) => (_jsxs("button", Object.assign({ ref: ref, disabled: disabled, className: clsx("iui-btn", className, size, {
        primary,
        outlined,
        active,
    }), onClick: onClick, type: (buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.type) || onClick ? "button" : "submit" }, buttonProps, { children: [icon && _jsx(FontAwesomeIcon, { icon: icon }), _jsx("div", Object.assign({ className: "iui-btn-label" }, { children: label })), iconEnd && _jsx(FontAwesomeIcon, { icon: iconEnd })] }))));
